<div *ngIf="showOPWindow" class="ttmodal" id="observationWindow" click="mySelect.close()">
  <div id="observationWindowHeader" class="ttmodal__header">
    <span class="ttmodal__title">Add Observation Point</span>
    <div class="panel__header__button-container">

    </div>
  </div>
  <div class="ttmodal__body">
    <div style="width: 620px; height: 550px;margin-left: 30px;">
      <div style="display: flex; flex-direction: row;">
        <span style="align-self: center;min-width: 102px;">Name</span>
        <!-- <mat-form-field style="width:380px">
          <input matInput type="text" [(ngModel)]="Compname" #Compname_="ngModel" >
        </mat-form-field> -->

        <mat-form-field style="width: 56%">
          <input matInput placeholder="Observation Name" type="text"
              [(ngModel)]="Compname" ngDefaultControl required >
      </mat-form-field>
      </div>

      <div style="display: flex; flex-direction: row;">
        <span style="align-self: center;min-width: 102px;" >Component </span>
        <mat-form-field style="width: 56%;">
        <mat-select placeholder="Select Component" style="width: 345px" (selectionChange)="onchangeComponent($event)" [(ngModel)]="componentId" ngDefaultControl required>
          <mat-option value="" disabled selected>Select Component</mat-option>
          <mat-option *ngFor="let component of componentList" [value]="component.Id">{{component.Name}}</mat-option>
        </mat-select>
        </mat-form-field>

       
      </div>

      <div style="display: flex; flex-direction: row;">
        <span style="align-self: center;min-width: 102px;">Observation List</span>
        <mat-form-field style="width: 56%;">
        <mat-select placeholder="Select Observation"  multiple style="width: 345px"
          [(ngModel)]="ObservationID" ngDefaultControl>
          <mat-option *ngFor="let item of observationLists" [value]="item.Id">{{item.Name}}</mat-option>
        </mat-select>
        </mat-form-field>
        <button mat-icon-button (click)="gotoObservationListPage()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div style="display: flex; flex-direction: row;margin-top: -3%">
        <span style="align-self: center;min-width: 102px;">Question</span>
        <mat-form-field style="width: 56%;">
          <textarea matInput class="qstyle" type="text" [(ngModel)]="Qname" #Qname_="ngModel" ngDefaultControl></textarea>
        </mat-form-field>
      </div>

      <div  style="display: flex; flex-direction: row;margin-top: -3%">
        <span style="align-self: center;max-width: 102px;">Question Instructions</span>
        <mat-form-field style="width: 56%;">
          <textarea matInput class="qstyle" type="text" [(ngModel)]="Qdesc" #Qdesc_="ngModel" ngDefaultControl></textarea>
        </mat-form-field>
      </div>

      <input hidden type='file' (change)="onSelectOPQuestionImage($event)" #uploadImage>
      <div  style="width:280px; font-weight: bolder;display: flex; flex-direction: row;">
        <span style="align-self: center;min-width: 102px;">Add Question Image</span>
        <div (click)="uploadImage.click()">
          <i class="material-icons add-implement-image-icon">note_add</i>
          <img style="width:50px; height:50px" *ngIf="OPQuestionImage" [src]="sanitize(OPQuestionImage)">
        </div>
      </div>
     
      <div style="display: flex; flex-direction: row; margin-top: 2%;margin-bottom: 2%;">
        <span style="align-self: center;min-width: 102px;">Types</span>
        <mat-radio-group name="type" [(ngModel)]="TypeID" style="margin-left: 32px;">
          <mat-radio-button value="1" title="Thickness Measurement" #normal (change)="changeType($event)">Normal
          </mat-radio-button>
          <mat-radio-button value="2" title="Crack Measurement" #crack (change)="changeType($event)">Crack
          </mat-radio-button>
          <mat-radio-button value="3" title="Evaluation" #eval (change)="changeType($event)">Evaluation
          </mat-radio-button>
          <mat-radio-button *ngIf="enableSelection==true" value="4" title="Selection" #eval (change)="changeType($event)">Selection
          </mat-radio-button><br>
          <mat-radio-button *ngIf="enablePassFail==true" value="5" title="Pass/Fail" #eval (change)="changeType($event)">Pass/Fail
          </mat-radio-button>
          <mat-radio-button *ngIf="enableYesNo==true" value="6" title="Yes/No" #eval (change)="changeType($event)">Yes/No
          </mat-radio-button>
          <!-- <mat-radio-button value="4" title="FECRNormal" #FECRNormal (change)="changeType($event)">Normal-Range</mat-radio-button>
         <mat-radio-button value="5" title="FECRCrack" #FECRCrack (change)="changeType($event)">Crack-No Limits</mat-radio-button> -->
        </mat-radio-group>
      </div>

      <div style="display: flex; flex-direction: row;"*ngIf="TypeID==1">
        <span *ngIf="TypeID==1"  style="align-self: center;min-width: 118px;">Use Range</span>
        <mat-checkbox  *ngIf="TypeID==1" id="fecrNormal" [(ngModel)]="isFECRNormal" [checked]="isFECRNormal"
          style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
        </mat-checkbox>
      </div>
      <div style="display: flex; flex-direction: row;"  *ngIf="TypeID==2">
        <span  *ngIf="TypeID==2"  style="align-self: center;min-width: 102px;">Crack-Ignore Limits</span>
        <mat-checkbox *ngIf="TypeID==2" id="fecrCrack_" [(ngModel)]="isFECRCrack" [checked]="isFECRCrack"
          style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
        </mat-checkbox>
      </div>
      <div style="display: flex; flex-direction: row;">
        <span  style="align-self: center;min-width: 102px;">No of Readings</span>
        <mat-form-field style="width: 20%;">
          <input matInput type="number" min="0" max="5" step="1" [(ngModel)]="noOfReading"
            (focusout)="checkMaxReading()" title="{{sToolTip_NoOfReadings}}" #noOfReading_="ngModel"
            (keypress)="ValidateNumberInputs($event)" [disabled]="isDisabled">
        </mat-form-field>
      </div>

      
      <div style="display: flex; flex-direction: row;">
        <span style="align-self: center;min-width: 102px;" >Inspection Type</span>
        <mat-form-field style="width: 56%;">
        <mat-select placeholder="Select Inspection Type" style="width: 345px" [(ngModel)]="InspectionTypeID" ngDefaultControl>
          <mat-option value="" disabled selected>Select Inspection Type</mat-option>
          <mat-option *ngFor="let opt of InspectionTypeList" [value]="opt.ID">{{opt.Name}}</mat-option>
        </mat-select>
        </mat-form-field>

       
      </div>

      <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack ">
        <span   style="align-self: center;min-width: 102px;">Limit-New</span>
        <mat-form-field style="width: 20%;">
          <input matInput type="number"  [(ngModel)]="limitNew" (focusout)="checkPositive()" #limitNew_="ngModel"
             [disabled]="isDisabled">
            <span matSuffix>(mm)</span>
        </mat-form-field>
      
      </div>

      <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack && !isFECRNormal">
        <span *ngIf="isCrack" style="align-self: center;min-width: 102px;">Max Crack Length</span>
        <span *ngIf="isNormal" style="align-self: center;min-width: 102px;">Limit Worn</span>
        <mat-form-field style="width: 20%;">
          <input matInput type="number" [(ngModel)]="limitWorn" (focusout)="checkPositive()"
            #limitWorn_="ngModel"  [disabled]="isDisabled">
            <span matSuffix>(mm)</span>
        </mat-form-field>
     

      

      </div>

      <div style="display: flex; flex-direction: row;" *ngIf="!isFECRCrack && isFECRNormal">
        <span  style="align-self: center;min-width: 102px;">Limit-Range</span>
        <mat-form-field style="width: 20%;">
          <input matInput type="number" min="0" [(ngModel)]="limitRange" (focusout)="checkPositive()"
            #limitRange_="ngModel" [disabled]="isDisabled">
            <span matSuffix>(mm)</span>
        </mat-form-field>
       
      </div>

      <div style="display: flex; flex-direction: row;" *ngIf="isFECRCrack">
        <span  style="align-self: center;min-width: 102px;">Measurement</span>
        <mat-form-field   style="width: 20%;">
          <input matInput type="number" min="0" [(ngModel)]="measurement" (focusout)="checkPositive()"
            #measurement_="ngModel" (keypress)="ValidateNumberInputs($event)">
            <span matSuffix>(mm)</span>
        </mat-form-field>
       
      </div>

      <div>

          <mat-checkbox color="primary" [checked]="checkedImage" (change)="ChangeIsImage(IsImage)" [(ngModel)]="IsImage"> Need Image</mat-checkbox>
          <mat-checkbox color="primary" [checked]="checkedAnswe"  (change)="ChangeIsAnswer(IsAnswer)"  [(ngModel)]="IsAnswer"> Need Answer</mat-checkbox>
      </div>


      <div class="ttmodal__footer" style="margin-top: 5px;">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="saveObservation()"><span class="button__text">Create Point</span></a>
      </div>
    </div>
  </div>
</div>